import { createFileRoute } from "@tanstack/react-router";
import { NotFound } from "@/components/Organisms/NotFound";

/**
 * Catch-all splat route for unmatched admin paths
 *
 * This route catches any undefined paths under /admin/* and displays
 * the NotFound component wrapped in the Shell layout.
 *
 * Examples:
 * - /admin/nonexistent → Caught by this route
 * - /admin/users/unknown-id → Caught by this route
 * - /admin/settings/invalid → Caught by this route
 */
export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/$",
)({
	component: NotFound,
	// use the beforeLoad to then show the unauthorized component
});
